import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
/*------ Pages-----*/
import Header from "../Components/dashboard-navbar";
import TutorExam from "../Pages/tutor_exam/TutorExam";
import TutorExamEntrance from "../Pages/tutor_exam/TutorExamEntrance";
import TutorExamEnd from "../Pages/tutor_exam/TutorExamEnd";
import { Puff } from "react-loader-spinner";
import {
  setResultData,
  setSelectedSubject,
  setExamId,
  setTutorMark,
  setExamObj,
} from "../../../redux/slice/tutorExamSlice";
import { useDispatch, useSelector } from "react-redux";
import TutorExamEndDialog from "../Pages/tutor_exam/TutorExamEndDialog";
import SubjectiveDemo from "../Pages/tutor_exam/SubjectiveDemo";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import TutorTermsAndCondition from "../Pages/tutor_exam/TutorTermsAndCondition";
import SubjectiveResult from "../Pages/tutor_exam/SubjectiveResult";
import InterviewSection from "../Components/interviewForm";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const App = () => {
  const history = useNavigate();
  const [subList, setSubList] = useState([]);
  const [selectedSub, setSelectedSub] = useState([]);
  const [currentBase64, setCurrentBase64] = useState([]);
  const [keyArSend, setKeyArSend] = useState([]);
  const [subject, setSubject] = useState();
  const [resultStatus, setResultStatus] = useState();
  const [result, setResult] = useState();
  const [examId, setExamId] = useState();
  const [tutStatusVal , setTutStatusVal] = useState()
  const examObj = useSelector((state) => state.exam.examObj);
  console.log("✌️examObj --->", examObj);
  const [tutorId, setTutorId] = useState(
    JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id
  );
  const [timeOfTest, setTimeOfTest] = useState();
  const [tutStatusUpdate, setTutStatusUpdate] = useState(false);
  // const [temp_tutExam,setTemp_tutExam]=useState()
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  console.log(subList, "😏😏😏");

  const dispatch = useDispatch();

  var subjectList = [
    "Soil Mechanics",
    "Mass Transfer",
    "Business Math",
    "Physical chemistry",
  ];

  // let tutorId="EDUT808"

  useEffect(() => {
    const findForm2 = async () => {
      const find_examId = await axios.post(
        // "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutor/find_examId",
        "https://testapis4.el.r.appspot.com/api/tutorWeb/find_examId",
        //  "https://testapis4.el.r.appspot.com/api/tutorWeb/find_examId",
        {
          tutorId: tutorId,
        }
      );

      console.log({ debug_tutorId: find_examId });
      if (find_examId?.data?.success === true) {
        let exmId = find_examId?.data?.examId?.split("_")[1];
        let newId = +exmId + 1;
        // console.log({newId})
        let newId2 = tutorId + "_" + newId;
        // console.log({newId2})
        let get_subject_updated = [];
        //  find_examId?.data?.tutor_exam?.map((el)=>{
        //   exam_given.push(el.subject)
        //  })
        setTutStatusVal(find_examId.data.tutStatus)
        const get_subjects = await axios.get(
          "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
        );

        if (get_subjects) {
          // console.log({get_subjects:get_subjects?.data?.subVal[0][0]})
          // console.log({tutor_exam:find_examId?.data?.tutor_exam})
          let retestTrueSubjects = new Set();
          get_subject_updated = get_subjects?.data?.subVal;

          //storing subjects with retest true
          find_examId?.data?.tutor_exam?.forEach((el) => {
            get_subject_updated?.forEach((el2) => {
              if (el2[0] === el.subject) {
                if (el?.retest === true) {
                  retestTrueSubjects.add(el.subject);
                }else{
                  retestTrueSubjects.delete(el.subject)
                }

              }
            });
          });
          //filtering already written subjects
          get_subject_updated = await get_subject_updated?.filter((el2) => {
            return !find_examId?.data?.tutor_exam.some(
              (el) => el.subject === el2[0]
            );
          });
          console.log({ retestTrueSubjects , get_subject_updated });
          //pushing retest true
          retestTrueSubjects.forEach((eachSub) =>
            get_subject_updated.push([eachSub])
          );
          // console.log({ retestTrueSubjects ,get_subject_updated }, "⚡⚡");
          setSubList(get_subject_updated);
          setExamId(newId2);
          // dispatch(setExamId(newId2));
          setLoading(false);
        }
        if (find_examId.data.lastExamId) {
          if (
            find_examId.data.tutStatus === "mcqe" &&
            location.pathname !== "/tutor_exam/submitted"
          ) {
            history("/tutor_exam/submitted",{replace:true});
            window.location.reload();
          } else if (
            find_examId.data.tutStatus === "subs" &&
            location.pathname !== "/tutor_exam/subjective_sheet"
          ) {
            history("/tutor_exam/subjective_sheet",{replace:true});
            window.location.reload();
          } else if (
            find_examId.data.tutStatus === "sube" &&
            location.pathname !== "/tutor_exam/subjective_result"
          ) {
            history("/tutor_exam/subjective_result",{replace:true});
            window.location.reload();
          }else if (
            (find_examId.data.tutStatus === "intrvfm" || find_examId.data.tutStatus === "intrvreg" || find_examId.data.tutStatus === "intrvres") &&
            location.pathname !== "/tutor_exam/interviews"
          ) {
            history("/tutor_exam/interviews",{replace:true});
            window.location.reload();
          }
        } else if (
          (find_examId.data.tutStatus === "intrvfm" || find_examId.data.tutStatus === "intrvreg" || find_examId.data.tutStatus === "intrvres") &&
          location.pathname !== "/tutor_exam/interviews"
        ) {
          history("/tutor_exam/interviews",{replace:true});
          window.location.reload();
        }
      }else if(!find_examId?.data?.success && find_examId?.data?.tutStatus && (find_examId.data.tutStatus === "intrvfm" || find_examId.data.tutStatus === "intrvreg" || find_examId.data.tutStatus === "intrvres")){
        setTutStatusVal(find_examId.data.tutStatus)
        if (
          // (find_examId.data.tutStatus === "intrvfm" || find_examId.data.tutStatus === "intrvreg" || find_examId.data.tutStatus === "intrvres") &&
          location.pathname !== "/tutor_exam/interviews"
        ) {
          history("/tutor_exam/interviews",{replace:true});
          window.location.reload();
        }
      } else {
        console.log("entering here in new tut id");
        let exmId = tutorId + "_1";
        const get_subjects = await axios.get(
          "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
        );
        console.log({ get_subjects });
        if (get_subjects) {
          // console.log(exmId, "<><><><><><><> exm id");

          console.log(get_subjects?.data?.subVal, "🥲🥲<>");

          setSubList(get_subjects?.data?.subVal);
          setExamId(exmId);
          setLoading(false);
        }
        // console.log({tutId})
      }
    };
    findForm2();
  }, [tutorId, history, location , tutStatusUpdate]);

  // const SelectedSub = (e) => {
  //   setSelectedSub([e]);
  // };
  const SelectedSub = (e) => {
    setSelectedSub(e, "eeeeeee");
    dispatch(setSelectedSubject(e));
  };

  const CurrentBase64_func = (val) => {
    console.log({ valbase64: val });
    setCurrentBase64(val);
  };

  const key_func = (value) => {
    setKeyArSend(value);
  };
  const setResult_func = (value) => {
    setResult(value);
    dispatch(setResultData(value));
  };

  const setResultStatus_func = (value) => {
    console.log(value, "in exam end");
    setResultStatus(value);
    dispatch(setTutorMark(value));
  };

  const setSubject_func = (value) => {
    setSubject(value);
    console.log({ subject });
  };

  const setLocalSt = (temp_tutorObj) => {
    let tutor_stringified = JSON.stringify(temp_tutorObj);
    localStorage.setItem("tutor", tutor_stringified);
  };

  // useEffect(()=>{

  //   setLocalSt(temp_tutExam)
  //  },[temp_tutExam])
  return (
    <Fragment>
      <Header
        name={JSON.parse(localStorage?.getItem("tutor"))?.saveTutor?.name}
        saveTutor={JSON.parse(localStorage?.getItem("tutor"))?.saveTutor}
      />
      <Router>
        <Routes>
          <Route exact path="/tutor_exam">
            {loading && (
              <div style={{ marginLeft: "45%", marginTop: "20%" }}>
                <Puff
                  heigth="100"
                  width="100"
                  color="#01b1b1"
                  ariaLabel="loading"
                />
              </div>
            )}
            {!loading && (
              <TutorExamEntrance
                subList={subList}
                SelectedSub={SelectedSub}
                CurrentBase64_func={CurrentBase64_func}
                key_func={key_func}
                setTimeOfTest={setTimeOfTest}
                setLocalSt={setLocalSt}
              />
            )}
          </Route>
          <Route path="/tutor_exam/sheet">
            <TutorExam
              subjectList={selectedSub}
              currentBase64={currentBase64}
              keyArSend={keyArSend}
              setResult_func={setResult_func}
              setResultStatus_func={setResultStatus_func}
              timeOfTest={timeOfTest}
              setSubject_func={setSubject_func}
              examId={examId}
              tutorId={tutorId}
              setLocalSt={setLocalSt}
            />
          </Route>
          <Route path="/tutor_exam/subjective_sheet">
            <SubjectiveDemo
              examId={examId}
              tutorId={tutorId}
              subjectList={selectedSub}
            />
          </Route>
          <Route path="/tutor_exam/terms_condition">
            <TutorTermsAndCondition
              examId={examId}
              tutorId={tutorId}
              result={result}
              resultStatus={resultStatus}
              subjectList={selectedSub}
            />
          </Route>
          <Route path="/tutor_exam/submitted">
            <TutorExamEnd
              subject={selectedSub}
              result={result}
              resultStatus={resultStatus}
              examId={examId}
            />
          </Route>
          <Route path="/tutor_exam/subjective_result">
            <SubjectiveResult
              subject={selectedSub}
              examId={examId}
              tutorId={tutorId}
            />
          </Route>
          <Route path="/tutor_exam/interviews">
            <InterviewSection
              tutorId={tutorId}
              tutStatus={tutStatusVal}
              tutStatusUpdate = {tutStatusUpdate}
              setTutStatusUpdate = {setTutStatusUpdate}
            />
          </Route>
        </Routes>
      </Router>
    </Fragment>
  );
};

export default App;
